export const mapRecord = <K extends string | number | symbol, VIn, VOut>(
    record: Record<K, VIn>,
    map: (key: K, value: VIn) => VOut,
): Record<K, VOut> => {
    const entries = Object.entries(record);
    const mappedEntries = entries.map(([key, value]) => [key as K, map(key as K, value as VIn)] as const);
    return Object.fromEntries(mappedEntries) as Record<K, VOut>;
};
